import React, { useState, useEffect, useContext } from 'react';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import './DatePicker.scss';

export default ({ onChange, date = new Date() }) => {
  const [currentDate, setCurrentDate] = useState(date);

  const onDayClick = (e) => {
    setCurrentDate(e);
  }

  useEffect(() => {
    if (currentDate) {
      if (onChange) {
        onChange(currentDate);
      }
    }
  }, [currentDate])

  return (
    <div className="date-picker-wrapper">
      <div className="date-picker">
        <DayPicker
          selectedDays={[currentDate]}
          onDayClick={onDayClick}
        />
      </div>
    </div>
  )

}